module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAVCAYAAACdbmSKAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAQ9JREFUeNrUU+0JwjAQjbUDuIG6Qf0YoN3ADVQE8Z+4gU5Qf4ogdgQ3UH8KSruBcYNuoO/kouFMxL8ePBKavHd3L1elHDEaT+bAXXmi4iDEWPrAAEj4c7FZr8oPEqljmQI1T4IZiEvahEzYsvK3eIkFIESCoIED7xfADihtdugoZwhQXzHKmXMlNfte6CijL5XZhLcRUGlgvXr6yIAjlWi7V80v57Ld6Va4JBnUbw+Y4M4Jd7W0nA5ToOHJSplayKgDq24qoUkH9Jh8SQvLny4HUg5EQyhYwI76i8Rm/BI32/KUZ65gt4xILkjaJpnHiz0umqHNnD19ea/ENeWRNSqpmWz5W3gDAnuC+s94CDAATjVZrr0GXRIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/media/signomorado gastos.png
// module id = 104
// module chunks = 0